// @ts-nocheck
/* eslint-disable */
(function() {
	class Card {
		constructor() {
			this._container = Mapy.Util.node("div", { className: "map-card" });
			this._body = Mapy.Util.node("div");

			this._container.appendChild(this._body);
		}

		get container() {
			return this._container;
		}

		get body() {
			return this._body;
		}

		open(options) {
			// nejdriv vlozime do DOMu, aby to ziskalo rozmery
			document.body.appendChild(this._container);

			// ziskame potrebna cisla
			const width = this._container.clientWidth;
			const height = this.container.clientHeight;
			const bbox = options.bbox || document.body.getBoundingClientRect();
			const offsetX = options.offsetX || 0;
			const offsetY = options.offsetY || 0;
			const x = options.x || (bbox.right - bbox.left) / 2;
			const y = options.y || (bbox.bottom - bbox.top) / 2;

			// napocitame popup
			let left = x + offsetX - (width / 2);
			let bottom = bbox.bottom - y - offsetY;

			// popup moc vpravo, posuneme doleva
			if (bbox.right - (left + width) < 0) {
				left += bbox.right - (left + width);
			}

			// popup moc vpravo, posuneme doprava
			if (left < bbox.left) {
				left = bbox.left;
			}

			// popup moc dole, posuneme nahoru - to se realne asi nemuze stat
			if (bottom < 0) {
				bottom = 0;
			}

			// popup moc nahore, posuneme dolu
			if (bbox.bottom - (bottom + height) < 0) {
				bottom = bbox.bottom - height;
			}

			// nastavime vyslednou pozici elementu
			Object.assign(this._container.style, {
				left: `${Math.floor(left)}px`,
				bottom: `${Math.floor(bottom)}px`,
			});
		}

		close() {
			this._container.remove();
		}
		
		destroy() {
			this.close();
		}
	}

	Mapy.Card = Card;
}());
